import _ from 'lodash';
import { makeAutoObservable } from 'mobx';

class AvatarListState {
  moreAvatarsModalOpen = false;
  size = 'sm';
  type = 'overlap';
  limit = 3;
  linkable = false;
  employees;
  moreModalEnabled = false;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({size, type, employees, limit, linkable, moreModalEnabled}) {
    this.size = size || this.size;
    this.type = type || this.type;
    this.limit = limit || this.limit;
    this.linkable = linkable || this.linkable;
    this.employees = employees;
    this.moreModalEnabled = moreModalEnabled;
  }

  openMoreAvatarsModal() {
    if (this.moreModalEnabled) {
      this.moreAvatarsModalOpen = true;
    }
  }

  closeMoreAvatarsModal() {
    this.moreAvatarsModalOpen = false;
  }

  get moreEmployeesOption() {
    return this.limit < this.employees.length;
  }

  get moreAvatar() {
    return {
      size: this.size,
      className: 'Avatar--more',
      employee: {
        avatarInitials: `+${this.employees.length - this.limit}`,
        avatarColour: 'bg-whale'
      }
    };
  }

  get avatarListSize() {
    return this.size === 'xs' ? 'sm' : this.size;
  }

  get employeeList() {
    return _.take(this.employees, this.limit);
  }

  get moreEmployeesList() {
    return _.difference(this.employees, this.employeeList);
  }

  calculateZIndex(index) {
    if (this.type !== 'overlap') {
      return 'auto';
    }

    return 300 - index;
  }
}

export default AvatarListState;
